function CustomOptionsCtrl(customOptionsService, toaster, $timeout, $q) {
  let ctrl = this,
    canceler = null,
    timeoutId;
  ctrl.$onInit = function () {
    // ключ перерисовки шаблона, см. compile в customOptionsDirective
    ctrl.renderKey = 0;
    ctrl.getData();
  };
  ctrl.$onChanges = function (changes) {
    if (changes.offerId && !changes.offerId.isFirstChange()) {
      ctrl.getData();
    }
  };
  ctrl.getData = function () {
    customOptionsService.getData(ctrl.productId, ctrl.offerId).then(function (customOptions) {
      // перезагрузка (смена offerId) — пересоздаём разметку под новые объекты опций
      if (ctrl.items != null) {
        ctrl.renderKey += 1;
      }
      ctrl.items = customOptions;
      ctrl.items.forEach(function (item) {
        ctrl.initSelect(item);
      });
      $timeout(() => {
        customOptionsService.get(ctrl.productId, ctrl.items).then(data => {
          ctrl.xml = data.xml;
          ctrl.jsonHash = data.jsonHash;
          if (data.error != null) {
            toaster.pop('error', '', data.error);
          }
          if (ctrl.initFn != null) {
            ctrl.initFn({
              customOptions: ctrl
            });
          }
          ctrl.changeFn();
        });
      }, 0);
    });
  };
  ctrl.eventDebounce = function (value, item, option, customOptionComboView = false) {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(ctrl.change.bind(ctrl, value, item, option, customOptionComboView), 0);
  };
  ctrl.change = function (value, item, option, customOptionComboView = false) {
    if (value == null) {
      if (item.DefaultQuantity != null) {
        item.DefaultQuantity = item.MinQuantity || 0;
      } else {
        option.DefaultQuantity = option.MinQuantity || 0;
      }
    }
    if (option) {
      if (item.InputType === 6) {
        if (option.MaxQuantity > 1 && option.DefaultQuantity === 0) {
          option.Selected = false;
        }
        if (item.IsRequired) {
          const selectedCount = item.Options.filter(itemOption => itemOption.Selected).length;
          if (selectedCount === 0) {
            option.Selected = true;
          }
        }
      }
      if (item.InputType === 2) {
        if (item.MaxQuantity > 1) {
          item.Selected = !(option.DefaultQuantity === 0 && item.IsRequired === false);
        }
      }
      if (!ctrl.isValidQuantity(option.DefaultQuantity || 1, item, option)) {
        option.Selected = false;
        return;
      }
    }
    if (canceler) {
      canceler.resolve();
    }
    canceler = $q.defer();
    customOptionsService.get(ctrl.productId, ctrl.items, canceler.promise).then(data => {
      if (!data) return;
      ctrl.xml = data.xml;
      ctrl.jsonHash = data.jsonHash;
      if (data.error != null) {
        toaster.pop('error', '', data.error);
      }
      ctrl.changeFn({
        item
      });
    });
  };
  ctrl.findSelectedOptionByOptionId = function (selectedOption, options) {
    return options.find(it => selectedOption.OptionId === it.OptionId);
  };
  ctrl.isValidQuantity = function (nextValueOption, item, option) {
    const isValid = customOptionsService.isValidAddOption(nextValueOption, item, option);
    if (isValid === false) {
      ctrl.notifyWarning(`Вы можете выбрать из этой группы не больше ${item.MaxQuantity} товаров`);
    }
    return isValid;
  };
  ctrl.notifyWarning = function (text) {
    toaster.pop('warning', '', text);
  };
  ctrl.extractSelectedOptions = function (item, fallback) {
    if (item.SelectedOptions == null) return fallback !== undefined ? fallback : null;
    if (Array.isArray(item.SelectedOptions)) {
      return item.SelectedOptions.length > 0 ? item.SelectedOptions[0] : fallback !== undefined ? fallback : null;
    }
    return item.SelectedOptions;
  };
  ctrl.initSelect = function (item) {
    if (item.SelectedOptions != null) {
      if (!Array.isArray(item.SelectedOptions)) {
        item.SelectedOptions = [item.SelectedOptions];
      }
      if (item.InputType === 6 && item.SelectedOptions?.every(it => it.DefaultQuantity === 0)) {
        item.SelectedOptions.length = 0;
      } else {
        const selectedOptions = [];
        item.Options.forEach(option => {
          const selectedOption = item.SelectedOptions.find(selectedOption => selectedOption.OptionId === option.OptionId);
          if (!selectedOption) return;
          option.Selected = true;
          option.DefaultQuantity = selectedOption.DefaultQuantity;
          selectedOptions.push(option);
        });
        if (selectedOptions.length > 0) {
          item.SelectedOptions = selectedOptions;
        }
      }
    } else {
      if (item.InputType === 3 || item.InputType === 4) {
        item.SelectedOptions = item.Options[0];
      } else if (item.IsRequired && item.InputType === 6) {
        item.Options[0].Selected = true;
        item.SelectedOptions = [item.Options[0]];
      } else {
        item.SelectedOptions = item.IsRequired ? [item.Options[0]] : null;
      }
    }
    if (item.InputType === 0 || item.InputType === 1) {
      item.SelectedOptions = ctrl.extractSelectedOptions(item);
    }
  };
  ctrl.isSelectedOption = function (item, option) {
    let selectedOption = item.SelectedOptions;
    let optionId = selectedOption == null ? null : Array.isArray(selectedOption) ? selectedOption[0]?.OptionId : selectedOption.OptionId;
    return selectedOption != null && optionId === option.OptionId;
  };

  // если нет label для checkbox`a
  // из за label вызывается change 2 раза (от spinbox и label)
  ctrl.selectOption = function (item, option) {
    if (item.InputType === 2 && (item.MaxQuantity === 1 || item.MaxQuantity == null)) {
      item.Selected = !item.Selected;
      ctrl.change(item.Selected, item, option);
    }
  };
}
CustomOptionsCtrl.$inject = ["customOptionsService", "toaster", "$timeout", "$q"];
export default CustomOptionsCtrl;